export enum Availability {
  Available = 'Available',
  Error = 'Error',
  NotAvailable = 'NotAvailable',
}